<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <el-select
        v-model="tableParams.isTime"
        filterable

        placeholder="显示类型"
        style="margin-right: 15px;width: 110px">
        <el-option label="正常显示" :value="0" />
        <el-option label="按月份" :value="1" />
        <el-option label="按年份" :value="2" />
      </el-select>
      <search-channel-slot-select v-model="tableParams.slotId" :channel-id="tableParams.channelId" />
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px;" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;"></table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        @sort-change="sortChange"
        :header-cell-style="{background:'#fafafa'}"
        :summary-method="tableSummary"
        show-summary
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%">
          <el-table-column v-if="tableParams.isTime" sortable prop="timeHour" label="上报时间" align="center" />
          <el-table-column
            v-for="(v, i) in checkColumns"
            :prop="v.field"
            :label="v.title"
            :width="v.width"
            :min-width="v.minWidth"
            :sortable="['reportDate','showSmt','clkSmt','downPrice','income'].indexOf(v.field) > -1"
            :key="i"
            align="center">
            <template v-slot="scope">
              <el-tag v-if="v.field === 'clickRate' || v.field === 'fillingRate' || v.field === 'bidRate' || v.field === 'showRat'" type="info">{{ scope.row[v.field] }}%</el-tag>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>
  </div>
</template>

<script>
import SearchChannelSlotSelect from '@/components/SearchChannelSlotSelect'
import TableColumn from '@/components/TableColumn'
import initTableMixin from '@/mixins/initTable'

import BaseDatePicker from '@/components/BaseDatePicker'

export default {
  name: 'manageReportCPD',
  components: {
    SearchChannelSlotSelect,
    BaseDatePicker,
    TableColumn
  },
  mixins: [initTableMixin],
  data () {
    return {
      searchDate: undefined,
      columns: [
        { field: 'reportDate', title: '日期' },
        { field: 'slotId', title: '广告位ID' },
        { field: 'slotName', title: '广告位名称' },
        { field: 'showSmt', title: '展示次数' },
        { field: 'clkSmt', title: '点击次数' },
        { field: 'downPrice', title: '下载单价' },
        { field: 'income', title: '收入' }
      ],
    }
  },
  created () {
    this.tableParams.isTime = 0
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/report/MediaDsp/list'
      return true
    },
    changeDate (date) {
      this.tableParams.start = date.startTime
      this.tableParams.finish = date.endTime
    },
    tableSummary (row) {
      const arr = ['showSmt', 'clkSmt', 'income']
      const fixedArr = ['income']
      const {data } = row
      let checklists=this.checkColumns.map(item=>{
        return item.field
      })
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out[i] = arr.indexOf(checklists[i]) > -1 ? (data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0)).toFixed(2) : '-'
          } else {
            out[i] = arr.indexOf(checklists[i]) > -1 ? data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0) : '-'
          }
        }
      }
      return out
    },
    toQuery () {
      this.pagination.pageNum = 1
      if (!this.isTime && (this.tableParams.asc === 'timeHour' || this.tableParams.desc === 'timeHour')) {
        this.tableParams.asc = ''
        this.tableParams.desc = ''
      }
      this.init()
    },
    sortChange (column) {
      this.tableParams.asc = ''
      this.tableParams.desc = ''
      if (column.order === 'ascending') {
        this.tableParams.asc = column.prop
      } else {
        this.tableParams.desc = column.prop
      }
      this.init()
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper{
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  &>*{
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child{
      margin-right: 0;
    }
  }

  &>.el-select,&>.el-input{
    width: 220px;
  }
}

.table-wrapper{
  padding: 15px;
  background: #ffffff;
  .table__operation{
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
